// ref: https://github.com/vercel-labs/await-interaction-response
// to yield back to main thread (let main thread continues working/painting). ref: https://kurtextrem.de/posts/improve-inp

export default function interactionResponse(): Promise<unknown> {
  return new Promise((resolve) => {
    setTimeout(resolve, 100); // Fallback for the case where the animation frame never fires.
    requestAnimationFrame(() => {
      setTimeout(resolve, 0);
    });
  });
}
